//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('ftpAccounts', {
//        templateUrl: 'views/components/views/ftpAccounts/ftpAccounts.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ftpAccountsService', function (stateService, ftpAccountsService) {
//            const vm = this;
            
//            vm.model = {
//                itemsListFtpAccounts: []
//            };

//            async function loadFtpAccounts() {
//                vm.model.itemsListFtpAccounts = (await ftpAccountsService.listFtpAccounts());
//            }

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'ftpaccount':
//                        go({ ftpaccount_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };
            
//            vm.$onInit = function () {
//                loadFtpAccounts();
//            };
//        }]
//    });
//})();
